import checkIfBlockIsVisible from "./checkIfBlockIsVisible";
import checkIfStepIsVisible from "./checkIfStepIsVisible";

export const getBlock = (configurations, id) =>
  configurations.find((c) => c.id === id);

const convertSurveyResponses = (newResponses, context, parseValues=true) => {
  const { configuration, responses } = context;
  const convertedResponses = newResponses.reduce((acc, response) => {
    const question = getBlock(configuration, response.configuration_input_id);

    // target question might be inactive (i.e. not present in the list of configurations), thus the variable might be
    // null. if that's the case, simply skip it
    if (!question)
      return acc;

    if (question.type === 'recursive_question')
      question.blocks = configuration.filter((c) => c.recursive_question_id === question.id);

    let option = null;

    if (response.configuration_option_id) {
      option = configuration.find(
        (c) => c.id === response.configuration_option_id
      );
    }

    const value = parseValues
      ? JSON.parse(response.value)
      : response.value;

    return {
      ...acc,
      [response.configuration_input_id]: {
        ...response,
        question,
        savedValue: value,
        value,
        ...(option ? { option } : {}),
      },
    };
  }, {});

  const mergedResponses = { ...responses, ...convertedResponses };

  return Object.keys(mergedResponses).reduce((acc, questionId) => {
    const response = mergedResponses[questionId];
    const step = getBlock(context.data, response.question.step_id);

    const isVisibleStep = checkIfStepIsVisible(step, {
      ...context,
      responses: mergedResponses,
    });
    const isVisibleBlock = checkIfBlockIsVisible(response.question, {
      ...context,
      responses: mergedResponses,
    });
    const hidden = !response.autogenerated && (!isVisibleStep || !isVisibleBlock);

    if (!hidden) {
      return { ...acc, [questionId]: response };
    }

    return { ...acc, [questionId]: { ...response, hidden } };
  }, {});
};

export default convertSurveyResponses;
